import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';

import {
  HierarchyAction,
  receivedGetHierarchyFail,
  receivedGetHierarchySuccess,
  startHierarchyLoading,
} from './actions';
import getHierarchyEntities from './resources';

type HierarchyThunkResult<R> = ThunkAction<Promise<R>, RootState, unknown, HierarchyAction>;

/**
 * Gets a list of data sources
 */
export const listHierarchy = (): HierarchyThunkResult<void> => (dispatch) => {
  dispatch(startHierarchyLoading());
  return getHierarchyEntities()
    .then((response) => {
      dispatch(receivedGetHierarchySuccess(response));
    })
    .catch((response) => {
      dispatch(receivedGetHierarchyFail(response.data));
    });
};
